import "./SpendVsPredictedReturns.css";

import { Bar } from "react-chartjs-2";

import { ColorConstants } from "../../../../../constants";
import { thousandsFormatterToLower } from "../../../../../utils";
import { Card } from "../../../../../widget";
import { maybeSetGlobalChartJsConfiguration } from "../../../../../widget/charts/utils";
import { useSpendVsPredictedReturns } from "./useSpendVsPredictedReturns";

maybeSetGlobalChartJsConfiguration();

interface SpendVsPredictedReturnsProps {
  plannedInvestment: number | undefined;
  predictedReturns: number | undefined;
}

export const SpendVsPredictedReturns = ({
  plannedInvestment,
  predictedReturns,
}: SpendVsPredictedReturnsProps): JSX.Element => {
  const { chartData, options } = useSpendVsPredictedReturns({
    plannedInvestment,
    predictedReturns,
  });

  return (
    <Card corners="rounded" padding="ml" height="100%">
      <p className="body01">Investment vs returns</p>
      <div className="SpendVsPredictedReturnsChart">
        <Bar data={chartData} options={options} />
      </div>
      <div className="SpendVsPredictedReturnsLegend">
        {[
          {
            label: "Planned investment",
            color: ColorConstants.VIOLET_500,
            value: thousandsFormatterToLower(plannedInvestment),
          },
          {
            label: "Predicted returns",
            color: ColorConstants.GREEN_500,
            value: thousandsFormatterToLower(predictedReturns),
          },
        ].map((item) => (
          <div className="SpendVsPredictedReturnsLegendItem" key={item.label}>
            <div
              className="SpendVsPredictedReturnsLegendSquare"
              style={{
                backgroundColor: item.color,
              }}
            />
            <div>
              <p className="body2" style={{ margin: 0 }}>
                {item.label}
              </p>
              <p className="body01" style={{ margin: 0 }}>
                {item.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
